/* ═══════════════════════════════════════════════════════════════════════════
   perf.js  —  Core Web Vitals JS layer for every Frappe website page

   Scope: images and iframes injected by JS after page load (product grids
   fetched via AJAX, YouTube gallery thumbnails, dynamic content).

   Why JS for these?
     The browser's native preload scanner runs during HTML parsing — before
     any JS executes.  For elements already in the initial HTML, setting
     loading="lazy" via JS is too late and has no effect (the browser has
     already queued the fetch).

     For elements injected by JS (AJAX responses, dynamic DOM construction),
     JS IS the right place to add these attributes because those elements
     never existed during the preload scan.

   OPT-OUT:
     data-no-perf on <body>  →  skip this engine entirely
   ═══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Optimise newly injected images ────────────────────────────────────── */
  /*
     For AJAX-injected images (webshop product grids, YouTube gallery renders,
     embed cards loaded after frappe.ready):
       loading="lazy"    — defers off-screen image fetches (effective here
                           because the preload scanner never saw these elements)
       decoding="async"  — browser decodes images off the main thread
  */
  function optimiseImages(root) {
    try {
      var sel = root.querySelectorAll ? root.querySelectorAll : null;
      if (!sel) return;

      sel.call(root, 'img:not([loading])').forEach(function (img) {
        img.setAttribute('loading',  'lazy');
        img.setAttribute('decoding', 'async');
      });

      sel.call(root, 'img[loading]:not([decoding])').forEach(function (img) {
        img.setAttribute('decoding', 'async');
      });

      /* Lazy-load iframes that are not already loading and have a real src */
      sel.call(root, 'iframe:not([loading])').forEach(function (iframe) {
        if (iframe.src && iframe.src !== 'about:blank') {
          iframe.setAttribute('loading', 'lazy');
        }
      });
    } catch (_) {}
  }

  /* ── MutationObserver ───────────────────────────────────────────────────── */
  /*
     Observes the entire document for newly added nodes.  Product grids
     (RfhqProductGrid), YouTube galleries (RfhqYoutubeGallery), and any
     other dynamically rendered content all trigger this.
  */
  /* Requires window.rfhqDom (rfhq_dom_observer.js — always the first import
     of websitehq.bundle.js). Never add a private MutationObserver here. */
  function initMO() {
    window.rfhqDom.onAdded(function (roots) {
      roots.forEach(optimiseImages);
    });
  }

  /* ── Boot ───────────────────────────────────────────────────────────────── */

  function boot() {
    if (document.body && document.body.hasAttribute('data-no-perf')) return;
    initMO();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

}());
